import contactActions from './contactActions';
export default {
  namespaced: true,
  state() {},
  getters: {},
  mutations: {},
  actions: contactActions,
};
